import React from "react";
import { Stack, TextField, MenuItem, Select, Button } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const FiltersBar = ({ filters, onFilterChange }) => {
  return (
    <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" mb={2}>
      <TextField
        size="small"
        placeholder="Search name..."
        value={filters.search}
        onChange={(e) => onFilterChange("search", e.target.value)}
      />
      <TextField
        size="small"
        placeholder="Email..."
        value={filters.email}
        onChange={(e) => onFilterChange("email", e.target.value)}
      />
      <Select
        size="small"
        value={filters.status}
        displayEmpty
        onChange={(e) => onFilterChange("status", e.target.value)}
        sx={{ minWidth: 150 }}
      >
        <MenuItem value="">Filter by Status</MenuItem>
        <MenuItem value="captured">Captured</MenuItem>
        <MenuItem value="failed">Failed</MenuItem>
        <MenuItem value="cancelled">Cancelled</MenuItem>
        <MenuItem value="pending">Pending</MenuItem>
        <MenuItem value="refunded">Refunded</MenuItem>
        <MenuItem value="authorized">Authorized</MenuItem>
      </Select>
      <Select
        size="small"
        value={filters.payment_gateway}
        displayEmpty
        onChange={(e) => onFilterChange("payment_gateway", e.target.value)}
        sx={{ minWidth: 180 }}
      >
        <MenuItem value="">Payment Gateway</MenuItem>
        <MenuItem value="razorpay">Razorpay</MenuItem>
        <MenuItem value="stripe">Stripe</MenuItem>
        <MenuItem value="paypal">PayPal</MenuItem>
      </Select>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Start Date"
          value={filters.startDate ? dayjs(filters.startDate) : null}
          onChange={(newValue) =>
            onFilterChange("startDate", newValue ? newValue.format("YYYY-MM-DD") : "")
          }
          slotProps={{ textField: { size: "small" } }}
        />
        <DatePicker
          label="End Date"
          value={filters.endDate ? dayjs(filters.endDate) : null}
          onChange={(newValue) =>
            onFilterChange("endDate", newValue ? newValue.format("YYYY-MM-DD") : "")
          }
          slotProps={{ textField: { size: "small" } }}
        />
      </LocalizationProvider>
      <Button variant="contained" color="primary" sx={{ textTransform: "none" }}>
        Export CSV
      </Button>
    </Stack>
  );
};

export default FiltersBar;
